import { z } from "zod"

import { EquivalencyType } from "@/graphql/codegen/graphql"

export const equivalentProductGroupFormSchema = z.object({
  equivalencyGroupId: z.string().optional(),
  name: z.string().min(1, "Name is required").max(255, "Name must be 255 characters or less"),
  type: z.nativeEnum(EquivalencyType, {
    required_error: "Type is required",
  }),
  notes: z.string().max(2048, "Note must be 2048 characters or less").default(""),
})

export type EquivalentProductGroupFormValues = z.infer<typeof equivalentProductGroupFormSchema>
